<template>
  <PageHeader
    title="Albumok"
    hero-class="bg-media hidden lg:flex"
    :breadcrumb="[ 'Médiatár','Albumok' ]"
  >
    <section
      @keyup.enter="$refs.search.submit()"
    >
      <div class="bg-white w-full p-6">
        <client-only>
          <MusicAlbumSearch
            ref="search"
            :query-object="queryObject"
            @searchChanged="searchChanged($event)"
          />
        </client-only>
      </div>
      <div 
        ref="entitiesList"
        class="bg-white w-full mt-7"
      >
        <ReOverlayLoader
          :loading="$fetchState.pending || isLoading"
          class="pb-8"
        >
          <RePagination
            :items="entities"
            :hide-page-selector="true"
            result-title="Albumok száma"
          />
          <div class="w-full flex flex-col lg:flex-wrap lg:flex-row bg-white">
            <div
              v-for="album in entities.data"
              :key="album.id"
              class="lg:w-1/4 p-4 "
            >
              <card
                class=" h-full cursor-pointer"
                :url="'/mediatar/albumok/' + album.id + '/' + album.slug"
                :title="album.title "
                :image="getMainImgObj(album)"
                card-color="bg-gray-lightest"
                :link-class="'block p-4'"
              >
                <p
                  v-if="album.performers.length > 0"
                  class="mt-4"
                >
                  <span
                    v-for="(performer, index) in firstThreePerformers(
                      album.performers
                    )"
                    :key="index"
                  >
                    {{
                      performer.name +
                        (index ===
                          firstThreePerformers(album.performers).length - 1
                          ? album.performers.length > 3
                            ? ", "
                            : ""
                          : ", ")
                    }}
                  </span>
                  <span v-if="album.performers.length > 3">...</span>
                </p>
                <p
                  v-else
                  class="mt-4"
                >
                  Ismeretlen
                </p>
                <p>
                  {{ album.publication_year }}
                </p>
              </card>
            </div>
          </div>
        </ReOverlayLoader>
      </div>
    </section>
  </PageHeader>
</template>

<script>
import { cloneDeep } from "lodash";
import MusicAlbumSearch from "~/components/folkradio/searches/MusicAlbumSearch.vue";
import PageHeader from "~/components/folkradio/PageHeader.vue";
import ReOverlayLoader from "~/components/rxt/recomponent/ReOverlayLoader.vue";
import card from '~/components/index/card.vue'
const RePagination = () =>
  import("~/components/rxt/recomponent/RePagination.vue");
import scrollMixin from "~/mixins/scroll-fetch"
export default {
  components: {
    RePagination,
    MusicAlbumSearch,
    PageHeader,
    ReOverlayLoader,
    card
  },
  mixins: [scrollMixin],
  head() {
    return {
      titleTemplate: "Albumok | Médiatár",
      meta: [
        { hid: "title", name: "title", content: "Albumok | Médiatár" },
        {
          hid: "og:title",
          name: "og:title",
          property: "og:title",
          content: "Albumok | Médiatár"
        },
        {
          hid: "og:image",
          name: "og:image",
          property: "og:image",
          content: this.$getDomain() + "/img/meta_default.png"
        },
        {
          hid: "description",
          name: "description",
          content: 'A Folkrádió hangtárában szereplő népzenei albumok kereshető listája'
        },
        {
          hid: "og:description",
          name: "og:description",
          property: "og:description",
          content: 'A Folkrádió hangtárában szereplő népzenei albumok kereshető listája'
        }
      ]
    };
  },
  data() {
    return {
      queryUrl: "/media/albums",
      loading: false
    };
  },
  computed: {
    queryObject() {
      return cloneDeep(this.$store.state.search.queryObject);
    }
  },
  watch: {
    $route(to, from) {
      this.$store.commit("search/setQueryObject", to.query);
      this.entities = {
        data: []
      }
      this.$fetch()
    }
  },
  async fetch() {
    let queryObject = { limit: 12, sort: "-created_at" };

    queryObject = Object.assign(
      queryObject,
      this.$router.history.current.query
    );

    this.$store.commit("search/setQueryObject", queryObject);

    await this.search();
  },
  methods: {
    firstThreePerformers(performers) {
      return performers.slice(0, 2);
    },
    //scroll fetch method
    getQueryString(){
      const queryObject = this.queryObject;

      this.$store.commit("search/setQueryObject", queryObject);

      return decodeURIComponent(
        this.$createQueryString(queryObject)
      );
    },
    searchChanged(queryObject) {
      this.$router.push({ query: queryObject });
    },
    dtformat(date, from, to) {
      return this.$moment(date, from).format(to);
    },
    getMainImgObj(album) {
      if (album.thumbnail) {
        return album.thumbnail;
      }
      return null;
    },
    getMainImg(album) {
      if (album.thumbnail) {
        return album.thumbnail.url;
      }
      return "/img/event-default_w240.jpg";
    }
  }
};
</script>

